import { AppState } from "../../../redux-configuration/AppState";

export const sendLoginConfirmationCodeLoadingSelector = (appState: AppState): boolean => appState.authentication.confirmation.loading
export const sendLoginConfirmationCodeErrorSelector = (appState: AppState): string | undefined => appState.authentication.confirmation.error
export const loginTokenSelector = (appState: AppState): string | undefined => appState.authentication.confirmation.token
